// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../shared/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../shared/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../shared/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../../../shared/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../styles/customMediaQueries.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserDetails_root__trzeB {
  margin: 20px 20px;
  gap: 24px;
}

.UserDetails_actionContainer__VW5nn {
  display: flex;
  align-items: center;
  gap: 10px;
}

.UserDetails_actionIcon__B5oI- {
  display: flex;
  cursor: pointer;
}

.UserDetails_actionsWrapper__afzP7 {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/views/UserDetails/UserDetails.module.css"],"names":[],"mappings":"AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX","sourcesContent":["@import \"../../styles/customMediaQueries.css\";\n\n.root {\n  margin: 20px 20px;\n  gap: 24px;\n}\n\n.actionContainer {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.actionIcon {\n  display: flex;\n  cursor: pointer;\n}\n\n.actionsWrapper {\n  display: flex;\n  justify-content: flex-end;\n  gap: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `UserDetails_root__trzeB`,
	"actionContainer": `UserDetails_actionContainer__VW5nn`,
	"actionIcon": `UserDetails_actionIcon__B5oI-`,
	"actionsWrapper": `UserDetails_actionsWrapper__afzP7`
};
export default ___CSS_LOADER_EXPORT___;
